module.exports = "https://static.energy5.com/_next/static/images/perfect5-00b60e28b1fce9dd48af356e53a36083.png";